// Import du logger en premier pour désactiver console.log en production
import "./utils/logger";

// Import des modules React
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import "react-toastify/dist/ReactToastify.css";
import "./i18n"; // Import de la configuration i18n
import App from "./App";
import "./index.css";
import axios from "axios";
import { APP_CONFIG } from "./config/app.config";

// Imports des providers
import { AuthProvider } from "./contexts/AuthContext";
import { WalletProvider } from "./contexts/WalletContext";
import { Web3Provider } from "./contexts/Web3Context";
import { ThemeProvider } from "./contexts/ThemeContext";
import { UserProvider } from "./contexts/UserContext";

// Configuration Axios
axios.defaults.timeout = APP_CONFIG.API.TIMEOUT;
axios.defaults.withCredentials = APP_CONFIG.API.WITH_CREDENTIALS;
axios.defaults.baseURL = APP_CONFIG.API.BASE_URL;

// Initialisation du service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch(() => {
        // Silencieux en production
      });
  });
}

// Ajouter des classes pour la détection JS
document.documentElement.classList.remove("no-js");
document.documentElement.classList.add("js");

// Composant d'erreur
const ErrorFallback = ({ message }) => (
  <div
    style={{
      padding: "20px",
      color: "white",
      backgroundColor: "#282c34",
      textAlign: "center",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    }}
  >
    <h1>Une erreur s'est produite</h1>
    <p>{message}</p>
  </div>
);

// Fonction pour rendre l'application de manière sécurisée
const renderApp = () => {
  try {
    const rootElement = document.getElementById("root");
    if (!rootElement) {
      throw new Error("Élément #root non trouvé dans le DOM");
    }

    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <UserProvider>
              <Web3Provider>
                <WalletProvider>
                  <App />
                  <SpeedInsights />
                  <Analytics />
                  <ToastContainer {...APP_CONFIG.TOAST} className="wide-toast-container" />
                </WalletProvider>
              </Web3Provider>
            </UserProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>,
    );
  } catch (error) {
    console.error("Erreur lors du rendu de l'application:", error);
    const rootElement = document.getElementById("root");
    if (rootElement) {
      const root = ReactDOM.createRoot(rootElement);
      root.render(
        <ErrorFallback message="Nous nous excusons pour ce problème. Veuillez rafraîchir la page ou réessayer plus tard." />,
      );
    }
  }
};

// Lancer le rendu de l'application
renderApp();
